import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionsTableRowStylesStyles = makeStyles((theme: Theme) =>
  createStyles({
    TableCellDiv: {
      display: "flex",
      alignItems: "center",
      color: "#252525",
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "left",
    },
    title: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#252525",
      fontFamily: theme.typography.fontFamily,
      lineHeight: "24px",
      width: "100px",
      textAlign: "left",
    },

    description: {
      marginBottom: "10px",
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      color: "#545454",
      fontFamily: theme.typography.fontFamily,
      textAlign: "left",
      lineHeight: "17px",
      width: "100px",
    },
    expandedStyle: {
      display: "flex",
      alignItems: "center",
      minHeight: "106px",
    },
    centerItem: {
      display: "flex",
      alignItems: "center",
    },
    button: {
      padding: "25px 25px 25px 25px",
    },
    dialogContent: {
      padding: "25px 20px 0px 20px",
    },
    saveNoteText: {
      color: "#FFFFFF",
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "left",
    },
    container: {
      background: "#FFFFFF",
      height: "90px",
      alignItems: "center",
    },
    iconStyle: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
    },
  }),
);
